// extracted by mini-css-extract-plugin
module.exports = {"disabled":"TaxAuthoritySelectBlock_disabled__kMQ3_","icon":"TaxAuthoritySelectBlock_icon__3QOc9","smMessage":"TaxAuthoritySelectBlock_smMessage__3p_dK"};